module.exports = __webpack_public_path__ + "9e4f913fb70d77b2898dd935c62b626a.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensanssemibolditalic.ttf
// module id = 694
// module chunks = 57